import type { Locale } from './locales';

/** In their own language, so people recognise them whatever the current one is. */
export const LOCALE_LABELS: Record<Locale, string> = {
  'en-US': 'English',
  'es-ES': 'Español',
};
